<template>
    <b-container>
        <b-col lg="12" class="ml-auto mx-auto">
            <div class="login-form-container mt-6 mb-6">
                <div class="login-form-header">
                    <div class="login-form-header-content">
                        <span v-if="signup || reset"
                              @click="showSignIn"
                              class="close top-left mt-2">
                            <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        </span>
                        <span @click="$emit('close')"
                              class="close top-right mt-2">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </span>
                        <h3 class="palette-white login-form-header-title">{{$t('login.title')}}</h3>
                    </div>
                </div>
                <p class="p-large text-center mt-5 mb-6 palette-black">{{$t("common.fair_donation")}}</p>
                <form class="col-lg-6 login-form" @submit.prevent="login">
                    <b-row class="mb-3">
                        <b-form-input v-model="email"
                                      type="text"
                                      id="inputEmail"
                                      class="login-form-input"
                                      :placeholder="$t('login.email')"
                                      required
                                      autocomplete="email"
                                      autofocus/>
                    </b-row>
                    <b-row class="mb-3" v-if="!reset">
                        <b-form-input v-model="password"
                                      type="password"
                                      id="inputPassword"
                                      class="login-form-input"
                                      :placeholder="$t('login.password')"
                                      required
                                      autocomplete="current-password"/>
                        <span v-if="signup && !isValidPassword(password)"
                              class="note float-left">
                        {{$t('user.too_short') }}</span>
                    </b-row>
                    <b-row class="mb-3" v-if="signup">
                        <b-form-input v-model="password2"
                                      type="password"
                                      id="inputPassword2"
                                      class="login-form-input"
                                      :disabled="!isValidPassword(password)"
                                      :placeholder="$t('user.confirm_password')"
                                      required/>
                        <span v-if="password2 && !validatePassword()"
                              class="note float-left">
                        {{$t('user.not_identical') }}</span>
                    </b-row>
                    <b-row class="mb-3" v-if="signup">
                        <b-form-input v-model="firstname"
                                      type="text"
                                      id="inputFirstname"
                                      class="login-form-input"
                                      :placeholder="$t('login.firstname')"
                                      required/>
                    </b-row>
                    <b-row class="mb-3" v-if="signup">
                        <b-form-input v-model="lastname"
                                      type="text"
                                      id="inputLastname"
                                      class="login-form-input"
                                      :placeholder="$t('login.lastname')"
                                      required/>
                    </b-row>
                    <b-row class="mb-3" v-if="signup">
                        <b-form-input v-model="phonenumber"
                                      type="text"
                                      id="inputPhoneNumber"
                                      class="login-form-input"
                                      :placeholder="$t('login.phonenumber')"
                                      required/>
                    </b-row>
                    <b-row>
                        <b-button type="submit"
                                  size="lg"
                                  variant="primary mx-auto m-0 mt-4 login-button">
                            <span>{{ getButtonText() }}</span>
                        </b-button>
                    </b-row>
                    <b-row class="mx-auto ml-auto mt-4 mb-4">
                        <div v-if="showForgot"
                             class="login-option-text"
                             @click.stop="resetPassword"
                        >
                            {{ $t('login.forgot_password') }}
                        </div>
                    </b-row>
                    <b-row class="mx-auto ml-auto mt-4 mb-4" v-if="!signup">
                        <div v-if="showForgot"
                             class="login-option-text"
                             @click="showSignUpForm"
                        >
                            {{ $t('login.not_user')}}
                        </div>
                    </b-row>
                    <b-row class="mx-auto ml-auto mt-4 mb-4" v-if="!signup">
                        <div v-if="showForgot"
                             class="login-option-text"
                             @click="showPrivacyPolicy"
                        >
                            {{ $t('privacy.title')}}
                        </div>
                    </b-row>
                </form>
            </div>
        </b-col>
        <b-modal
                ref="companyModal"
                centered
                no-close-on-esc
                no-close-on-backdrop
                hide-header-close
                hide-footer
                :title="$t('common.select_organization')">
            <div class="col-sm-12">
                <div
                        v-for="company in org"
                        :key="company.id"
                        class="company_selector"
                        @click.stop="fetchCompanyToken(company.id)">
                    {{ company.name }}
                </div>
            </div>
        </b-modal>
        <div
                v-if="loading"
                id="loader"
                class="spinner"
        />
    </b-container>

</template>

<script>
    import FairApi from '../modules/api'
    import {userRoles} from "../mixins/UserMixin";
    import {userHelper} from "../mixins/UserMixin";

    export default {
        name: 'login',
        mixins: [userHelper],
        props: {
            paymentForm: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                email: '',
                password: '',
                password2: '',
                firstname: '',
                lastname: '',
                phonenumber: '',
                loading: false,
                signup: false,
                org: null,
                showForgot: true,
                reset: false
            }
        },

        methods: {
            showSignIn: function () {
                this.signup = false
                this.showForgot = true
                this.reset = false
            },

            getButtonText: function () {
                if (this.signup) {
                    return this.$t('login.signup')
                } else if (this.reset) {
                    return this.$t('login.send_reset')
                }
                return this.$t('login.login')
            },

            login: function () {
                this.loading = true
                if (this.signup) {
                    if (this.validatePassword()) {
                        FairApi.post(FairApi.signup(), {
                            email: this.email,
                            first_name: this.firstname,
                            last_name: this.lastname,
                            password: this.password,
                            phonenumber: this.phonenumber
                        }, this.success, this.fail)
                    } else {
                        this.loading = false
                        this.$emit('alert', this.$t('user.not_identical'))
                    }
                } else if (this.reset) {
                    let resetLink = new URL(window.location.href).host + process.env.VUE_APP_PSW_RESET_LINK
                    FairApi.getWithParams(FairApi.userResetPsw(this.email), {link: resetLink},
                        this.resetSuccess, this.fail)
                } else {
                    FairApi.post(FairApi.login(), {
                        email: this.email,
                        password: this.password
                    }, this.success, this.fail)
                }
            },

            validatePassword: function () {
                return this.password === this.password2
            },

            resetSuccess: function() {
                this.loading = false
                this.$emit('resetClose')
            },

            showSignUpForm: function() {
                this.signup = true
                this.reset = false
                this.showForgot = false
            },

            showPrivacyPolicy: function () {
                this.$router.push({name: 'privacy-policy-view'})
            },

            success: function (result) {
                this.loading = false
                if (result.user.admin === true) {
                    if (this.paymentForm) {
                        this.$emit('alert', this.$t('payment.admin_login'))
                    } else {
                        this.saveUserCredentials(result)
                        this.$emit('loginAdmin')
                    }
                } else {
                    // select supervised organization, is needed
                    this.checkUserRights(result)
                }
            },

            checkUserRights: function (result) {
                let organizations = []
                result.user.rights.forEach(function(rightBundle) {
                    if (rightBundle.role.role === userRoles.ORGANIZATION_SUPER_USER) {
                        organizations.push(rightBundle.organization)
                    }
                })

                if (organizations.length === 1) {
                    this.saveUserCredentials(result)
                    this.fetchCompanyToken(organizations[0].id)
                } else if (organizations.length > 1) {
                    this.org = organizations
                    // allow user to select organization
                    this.saveUserCredentials(result)
                    this.$refs.companyModal.show()
                } else {
                    // normal user
                    this.saveUserCredentials(result)
                    this.$emit('loginUser')
                }
            },

            fetchCompanyToken: function(id) {
                this.$refs.companyModal.hide()
                this.loading = true
                FairApi.get(FairApi.organizationToken(id), this.successSupervisor, this.fail)
            },

            fail: function (response) {
                if (response) {
                    switch (response.status) {
                        case 403:
                            this.$emit('alert', this.$t('user.no_user'))
                            break
                        case 409:
                            this.$emit('alert', this.$t('user.duplicate_email'))
                            break
                        default:
                            this.$emit('alert', this.signup ? this.$t('login.sign_up_failed') : this.$t('login.failed'))
                    }
                } else {
                    this.$emit('alert', this.$t('common.fetch_failed'))
                }

                this.showForgot = true
                this.loading = false
            },

            successSupervisor: function (result) {
                this.loading = false
                if (result.token) {
                    this.saveUserCredentials(result)
                    this.$emit('loginUser')
                } else {
                    this.fail()
                }
            },

            saveUserCredentials: function(data) {
                this.$store.commit('storeToken', data.token)
                this.$store.commit('storeUser', data.user)
                FairApi.setHeader()
            },

            resetPassword: function () {
                this.reset = true
                this.showForgot = false
                this.signup = false
            }
        }
    }
</script>

<style scoped>
    .text-link,
    .text-link:active,
    .text-link:focus,
    .text-link:hover,
    .text-link:visited {
        color: #45B3C1;
        text-decoration: none;
        cursor: grab;
    }
</style>